
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-w-v-ia-wqg-8-r-6-sbr-e-2-u-jix-ji.json") })
        }
      }, "path---projects-w-v-ia-wqg-8-r-6-sbr-e-2-u-jix-ji");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---projects-w-v-ia-wqg-8-r-6-sbr-e-2-u-jix-ji!./.cache/json/projects-w-v-ia-wqg-8-r-6-sbr-e-2-u-jix-ji.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---projects-w-v-ia-wqg-8-r-6-sbr-e-2-u-jix-ji!./.cache/json/projects-w-v-ia-wqg-8-r-6-sbr-e-2-u-jix-ji.json
// module chunks = 15178676390636814000